import React from 'react';

const Button = ({ text = '', icon = null, onClick = null, type = "success" }) => (
  <button
    className={type ? `btn btn-${type}` : "btn"}
    onClick={onClick}
    type={type}
  >
    { icon ?? null}
    <span>{text}</span>
  </button>
);

export default Button;
